<!--
INTELLECTUAL PROPERTY NOTICE
© Orbit Tickets Ltd. All rights reserved.
This file contains Custom / Included Intellectual Property created for and owned by the Customer as part of an application developed by Kaleida within the Platform.
Custom / Included Intellectual Property may be used, reproduced, adapted, and incorporated into any application, system, or product developed by or on behalf of the Customer, whether or not such application forms part of the Platform, subject always to the terms of the agreement and provided that such use does not include or rely upon any Protected Intellectual Property of Kaleida Ltd.
For the avoidance of doubt, the inclusion of any application within the Platform does not restrict the Customer's right to use Custom / Included Intellectual Property outside of the Platform.
-->
<!-- IP-NOTICE: CUSTOM -->
<section class="orbit-list-page" aria-labelledby="customer-page-title">

	<mat-card>

		<mat-card-header>
			<mat-card-title class="page-title customer-detail-title">Customer Details</mat-card-title>

		</mat-card-header>
		<mat-card-content class="bottom-padding-0px">
			<list-filter title="Orders" [showFilters]="true" (filterChanged)="onFilterChanged($event)"
				(showFiltersChanged)="onShowFiltersChanged()">
				<order-search-list-filter class="filterContent" (isOrganiserUser)="setIsOrganiserUser($event)"
					[customerId]="customerId"></order-search-list-filter>
			</list-filter>
		</mat-card-content>
	</mat-card>
	<mat-card class="orbit-list-page__data-card">
		<mat-card-content>
			<order-search-list #orderList [isOrganiserUser]="isOrganiserUser"
				[customerId]="customerId"></order-search-list>
		</mat-card-content>
	</mat-card>
</section>